import { z } from "zod";

export const getMyCoverageAreasRequest = z.object({
  userId: z.coerce.number().positive().optional(),
});

export const assignUserCoverageAreaBodyRequest = z.object({
  userId: z.coerce.number().positive().optional(),
  cityIds: z.array(z.coerce.number().positive()).default([]),
});
